import { deliveryApi, paymentApi, custServiceApi, catalogueApi, numberPortApi, inventoryApi, orderApi } from '@/helpers/apis';
import axios from '@/helpers/axios';

export const getDeliverySlots = () => {
  const url = deliveryApi.GET_DELIVERY_SLOTS;
  return axios.get(url);
};

export const getAddressByPostalCode = (postalCode) => {
  const url = `${deliveryApi.GET_ADDRESS_POSTALCODE}/${postalCode}`;
  return axios.get(url);
};

export const getDeliveryAddressList = (brnCode) => {
  const url = deliveryApi.GET_DELIVERY_ADDRESS_LIST_BY_BRN;
  return axios.post(url, { brn: brnCode });
};

export const updateDeliveryAddress = (address) => {
  const url = deliveryApi.UPDATE_DELIVERY_ADDRESS;
  return axios.post(url, { ...address });
};

export const deleteDeliveryAddress = (address) => {
  const url = `${deliveryApi.DELETE_DELIVERY_ADDRESS}`;
  return axios.post(url, address);
};

export const getPaymentTypes = (brnCode, transactionType, msaheaderId) => {
  const url = paymentApi.FETCH_PAYMENTTYPE_AND_BALANCE;
  return axios.post(url, { brn: brnCode, transactionType, msaheaderId });
};

export const getBillingAddressList = ({ brn, page, size, searchParam }) => {
  const url = `${paymentApi.FETCH_BILLING_ADDRESS_LIST_BY_BRN}?page=${page}&size=${size}&&sortDir=DESC`;
  const payload = { brn: brn, searchParam: searchParam };
  return axios.post(url, payload);
};

export const getBillingAddressListServiceNo = (brnCode, serviceNumbers) => {
  const url = custServiceApi.BILLING_ADDRESS_SERVICENO;
  return axios.post(url, { brn: brnCode, svcNoList: serviceNumbers });
};

export const getPOPStationList = () => {
  const url = deliveryApi.GET_POPSTATION_LIST;
  return axios.get(url);
};

export const getPOPStationAddress = (postalCode) => {
  const url = `${deliveryApi.GET_POPSTATION_ADDRESS}/singapore+${postalCode}`;
  return axios.get(url);
};

export const getCustomerIds = (brnCode) => {
  const paylaod = { brn: brnCode };
  const url = deliveryApi.GET_CUSTOMER_IDS_BY_BRN;
  return axios.post(url, paylaod);
};

export const getAllDeliveryCharges = (msaheaderId) => {
  const url = `${deliveryApi.GET_ALL_DELIVERY_CHARGES}/${msaheaderId}`;
  return axios.get(url);
};

export const getSplitPaymentType = (brn) => {
  const brns = decodeURIComponent(brn);
  const url = `${deliveryApi.GET_SPLIT_PAYMENT_TYPE}/${brns}`;
  return axios.get(url);
};

export const pdpaRetreiveResidentialAddress = (brnCode) => {
  const url = deliveryApi.PDPA_RETRIEVE_RES_ADDRESS;
  return axios.post(url, { brn: brnCode });
};

export const pdpaSaveNewResAddress = (address) => {
  const url = deliveryApi.PDPA_SAVE_NEW_RES_ADDRESS;
  return axios.post(url, address);
};

export const pdpaUpdateExistResAddress = (address) => {
  const url = deliveryApi.PDPA_UPDATE_EXIST_ADDRESS;
  return axios.put(url, address);
};

export const pdpaDeleteExistResAddress = (id) => {
  const url = deliveryApi.PDPA_DELETE_EXIST_ADDRESS;
  return axios.put(url, id);
};

export const checkCustCodeEligibility = (payload) => {
  const url = catalogueApi.VALIDATE_EQUIPMENT_DEP_ADDON;
  return axios.post(url, payload);
};

export const getPortInDatesList = (payload) => {
  const url = numberPortApi.PORT_IN_DATE_LIST;
  return axios.post(url, payload);
};

export const getESimCardProfileType = (payload) => {
  const url = inventoryApi.ESIM_CARD_PROFILE_TYPE;
  return axios.post(url, payload);
};

export const uploadMultilineReceipientsESim = (fileData, cartId) => {
  const url = `${orderApi.UPLOAD_MULTILINE_RECP_ESIM}/${cartId}/multirecp`;
  return axios.post(url, fileData, { headers: { 'Content-Type': 'multipart/form-data' } });
}

export const uploadMultilineRetriggerESim = (fileData) => {
  const url = orderApi.UPLOAD_MULTILINE_RETRIGGER_ESIM;
  return axios.post(url, { ...fileData });
}

export const downloadMultilineReceipientsESim = (cartId) => {
  const payload={shoppingCartId:cartId}
  const url = orderApi.DOWNLOAD_MULTILINE_RECP_ESIM;
  return axios.post(url,payload);
}